import React from "react";

const NotFound = (props) => {
  return <div>Error 404 - Page not found</div>;
};

export default NotFound;
